import { callIntervalEntityName, messageTypeEntityName, repeatCallEntityName } from '@juvare/alert-ui/backend/config/classifiers';
import { accountSectionEntityName } from '@juvare/contact-management/backend/config/classifiers/AccountSectionClassifier/shared';
import { organizationSectionEntityName } from '@juvare/contact-management/backend/config/classifiers/OrganizationSectionClassifier/shared';
import { organizationTypeEntityName } from '@juvare/contact-management/backend/config/classifiers/OrganizationTypeClassifier/shared';
import { pagerCarrierEntityName } from '@juvare/contact-management/backend/config/classifiers/PagerCarrierClassifier/shared';
import { contactUsEntityName } from '@juvare/contact-management/backend/features/contact-us/shared';
import { groupEntityName } from '@juvare/contact-management/backend/features/groups/shared';
import { abmsCertificationEntityName } from '@juvare/credentialing/backend/config/classifiers/entities/defineAbmsCertificationClassifier';
import { abnsCertificationEntityName } from '@juvare/credentialing/backend/config/classifiers/entities/defineAbnsCertificationClassifier';
import { abppCertificationEntityName } from '@juvare/credentialing/backend/config/classifiers/entities/defineAbppCertificationClassifier';
import { aoaCertificationEntityName } from '@juvare/credentialing/backend/config/classifiers/entities/defineAoaCertificationClassifier';
import { aprnSpecialtyEntityName } from '@juvare/credentialing/backend/config/classifiers/entities/defineAprnSpecialtyClassifier';
import { ascpSpecialtyEntityName } from '@juvare/credentialing/backend/config/classifiers/entities/defineAscpSpecialtyClassifier';
import { boardOfPharmaceuticalSpecialtyEntityName } from '@juvare/credentialing/backend/config/classifiers/entities/defineBoardOfPharmaceuticalSpecialtyClassifier';
import { cardiovascularSpecialtyEntityName } from '@juvare/credentialing/backend/config/classifiers/entities/defineCardiovascularSpecialtyClassifier';
import { dentalSpecialtyEntityName } from '@juvare/credentialing/backend/config/classifiers/entities/defineDentalSpecialtyClassifier';
import { deploymentDurationEntityName } from '@juvare/credentialing/backend/config/classifiers/entities/defineDeploymentDurationClassifier';
import { deploymentTravelWillingnessEntityName } from '@juvare/credentialing/backend/config/classifiers/entities/defineDeploymentTravelWillingnessClassifier';
import { deploymentTypeEntityName } from '@juvare/credentialing/backend/config/classifiers/entities/defineDeploymentTypeClassifier';
import { driverLicenseEndorsementEntityName } from '@juvare/credentialing/backend/config/classifiers/entities/defineDriverLicenseEndorsementClassifier';
import { emergencyContactRelationshipEntityName } from '@juvare/credentialing/backend/config/classifiers/entities/defineEmergencyContactRelationshipClassifier';
import { eyeColorEntityName } from '@juvare/credentialing/backend/config/classifiers/entities/defineEyeColorClassifier';
import { hairColorEntityName } from '@juvare/credentialing/backend/config/classifiers/entities/defineHairColorClassifier';
import { hospitalEntityName } from '@juvare/credentialing/backend/config/classifiers/entities/defineHospitalClassifier';
import { incidentTypeEntityName } from '@juvare/credentialing/backend/config/classifiers/entities/defineIncidentTypeClassifier';
import { jasBoardEntityName } from '@juvare/credentialing/backend/config/classifiers/entities/defineJasBoardClassifier';
import { laboratoryTechnicianSpecialtyEntityName } from '@juvare/credentialing/backend/config/classifiers/entities/defineLaboratoryTechnicianSpecialtyClassifier';
import { languageEntityName } from '@juvare/credentialing/backend/config/classifiers/entities/defineLanguageClassifier';
import { languageFluencyEntityName } from '@juvare/credentialing/backend/config/classifiers/entities/defineLanguageFluencyClassifier';
import { maritalStatusEntityName } from '@juvare/credentialing/backend/config/classifiers/entities/defineMaritalStatusClassifier';
import { medicalRecordsItSpecialtyEntityName } from '@juvare/credentialing/backend/config/classifiers/entities/defineMedicalRecordsItSpecialtyClassifier';
import { mhcSpecialtyEntityName } from '@juvare/credentialing/backend/config/classifiers/entities/defineMhcSpecialtyClassifier';
import { occupationEntityName } from '@juvare/credentialing/backend/config/classifiers/entities/defineOccupationClassifier';
import { occupationCredentialEntityName } from '@juvare/credentialing/backend/config/classifiers/entities/defineOccupationCredentialClassifier';
import { occupationFunctionEntityName } from '@juvare/credentialing/backend/config/classifiers/entities/defineOccupationFunctionClassifier';
import { occupationGroupEntityName } from '@juvare/credentialing/backend/config/classifiers/entities/defineOccupationGroupClassifier';
import { occupationReportEntityName } from '@juvare/credentialing/backend/config/classifiers/entities/defineOccupationReportClassifier';
import { pharmacySpecialtyEntityName } from '@juvare/credentialing/backend/config/classifiers/entities/definePharmacySpecialtyClassifier';
import { priorCommitmentEntityName } from '@juvare/credentialing/backend/config/classifiers/entities/definePriorCommitmentClassifier';
import { professionalStatusEntityName } from '@juvare/credentialing/backend/config/classifiers/entities/defineProfessionalStatusClassifier';
import { radiologicSpecialtyEntityName } from '@juvare/credentialing/backend/config/classifiers/entities/defineRadiologicSpecialtyClassifier';
import { referralOptionEntityName } from '@juvare/credentialing/backend/config/classifiers/entities/defineReferralOptionClassifier';
import { skillEntityName } from '@juvare/credentialing/backend/config/classifiers/entities/defineSkillClassifier';
import { trainingEntityName } from '@juvare/credentialing/backend/config/classifiers/entities/defineTrainingClassifier';
import { tribeEntityName } from '@juvare/credentialing/backend/config/classifiers/entities/defineTribeClassifier';
import { veterinarianSpecialtyEntityName } from '@juvare/credentialing/backend/config/classifiers/entities/defineVeterinarianSpecialty';
import { writtenAbilityEntityName } from '@juvare/credentialing/backend/config/classifiers/entities/defineWrittenAbilityClassifier';
import { physicianAssistantExperienceEntityName } from '@juvare/credentialing/backend/config/classifiers/entities/definedPhysicianAssistantExperienceClassifier';
import { laboratoryTechnologistSpecialEntityName } from '@juvare/credentialing/backend/config/shared';
import {
    locationTypeEntityName,
    missionLocationEntityName,
    missionPositionEntityName,
    missionTypeEntityName,
} from '@juvare/missions/backend/config/classifiers';
import {
    ethnicityEntityName,
    genderEntityName,
    regionEntityName,
} from '@juvare/platform-sdk-react/backend/features/default-classifiers/shared';
import { ConfigurationTransferParams } from '@juvare/platform-sdk-react/ui/features/configuration-transfer/types/ConfigurationTransferParams';
import {
    occupationCTExportSchema,
    occupationCTImportSchema,
    professionalStatusCTExportSchema,
    professionalStatusCTImportSchema,
} from './configurationTransferSchemas';
import {
    mapExportOccupationData,
    mapExportProfessionalStatusData,
    mapImportOccupationData,
    mapImportProfessionalStatusData,
} from './configurationTransferUtils';

// ORDER MATTERS
export const classifiersListForConfigurationTransfer: ConfigurationTransferParams['classifiers'] = [
    {
        entityName: abmsCertificationEntityName,
        label: 'ABMS Certification',
    },
    {
        entityName: abnsCertificationEntityName,
        label: 'ABNS Certification',
    },
    {
        entityName: abppCertificationEntityName,
        label: 'ABPP Certification',
    },
    {
        entityName: accountSectionEntityName,
        label: 'Account Section',
    },
    {
        entityName: aoaCertificationEntityName,
        label: 'AOA Certification',
    },
    {
        entityName: aprnSpecialtyEntityName,
        label: 'APRN Specialty',
    },
    {
        entityName: ascpSpecialtyEntityName,
        label: 'ASCP Specialty',
    },
    {
        entityName: boardOfPharmaceuticalSpecialtyEntityName,
        label: 'Board Of Pharmaceutical Specialty',
    },
    {
        entityName: callIntervalEntityName,
        label: 'Call Interval',
    },
    {
        entityName: cardiovascularSpecialtyEntityName,
        label: 'Cardiovascular Specialty',
    },
    {
        entityName: contactUsEntityName,
        label: 'Contact Us',
    },
    {
        entityName: dentalSpecialtyEntityName,
        label: 'Dental Specialty',
    },
    {
        entityName: deploymentDurationEntityName,
        label: 'Deployment Duration',
    },
    {
        entityName: deploymentTravelWillingnessEntityName,
        label: 'Deployment Travel Willingness',
    },
    {
        entityName: deploymentTypeEntityName,
        label: 'Deployment Type',
    },
    {
        entityName: driverLicenseEndorsementEntityName,
        label: 'Driver License Endorsement',
    },
    {
        entityName: emergencyContactRelationshipEntityName,
        label: 'Emergency Contact Relationship',
    },
    {
        entityName: ethnicityEntityName,
        label: 'Ethnicity',
    },
    {
        entityName: eyeColorEntityName,
        label: 'Eye Color',
    },
    {
        entityName: genderEntityName,
        label: 'Gender',
    },
    {
        entityName: groupEntityName,
        label: 'Group Section',
    },
    {
        entityName: hairColorEntityName,
        label: 'Hair Color',
    },
    {
        entityName: hospitalEntityName,
        label: 'Hospital',
    },
    {
        entityName: incidentTypeEntityName,
        label: 'Incident Type',
    },
    {
        entityName: laboratoryTechnicianSpecialtyEntityName,
        label: 'Laboratory Technician Specialty',
    },
    {
        entityName: laboratoryTechnologistSpecialEntityName,
        label: 'Laboratory Technologist Special',
    },
    {
        entityName: languageEntityName,
        label: 'Language',
    },
    {
        entityName: languageFluencyEntityName,
        label: 'Language Fluency',
    },
    {
        entityName: locationTypeEntityName,
        label: 'Location Type',
    },
    {
        entityName: maritalStatusEntityName,
        label: 'Marital Status',
    },
    {
        entityName: medicalRecordsItSpecialtyEntityName,
        label: 'Medical Records IT Specialty',
    },
    {
        entityName: messageTypeEntityName,
        label: 'Message Type',
    },
    {
        entityName: mhcSpecialtyEntityName,
        label: 'MHC Specialty',
    },
    {
        entityName: missionLocationEntityName,
        label: 'Mission Location',
    },

    // start of occupation dependencies
    {
        entityName: jasBoardEntityName,
        label: 'JAS Board',
    },
    {
        entityName: occupationGroupEntityName,
        label: 'Occupation Group',
    },
    {
        entityName: occupationReportEntityName,
        label: 'Occupation MRC Report',
    },
    {
        entityName: occupationFunctionEntityName,
        label: 'Occupation Emergency Support Function',
    },
    {
        entityName: occupationCredentialEntityName,
        label: 'Occupation Credential',
    },
    // end of occupation dependencies

    // occupation dependencies need to be imported first, because
    // uuids are created dynamically and we need to map id > name
    // and vice versa on export/import
    {
        entityName: occupationEntityName,
        label: 'Occupation',
        onExportMapData: async (response) => {
            const occupation = occupationCTExportSchema.safeParse(response.data);
            if (!occupation.success) return response.data;

            const { default: defaultOccupationData, ...occupationData } = occupation.data;

            const mappedDefaultOccupationData = defaultOccupationData ? await mapExportOccupationData(defaultOccupationData) : undefined;
            const mappedOccupationData = await mapExportOccupationData(occupationData);

            return { ...mappedOccupationData, default: mappedDefaultOccupationData };
        },
        onImportMapData: async (importData) => {
            const occupation = occupationCTImportSchema.safeParse(importData);
            if (!occupation.success) throw Error('Invalid format');

            const { default: defaultOccupationData, ...occupationData } = occupation.data;

            const mappedDefaultOccupationData = defaultOccupationData ? await mapImportOccupationData(defaultOccupationData) : undefined;
            const mappedOccupationData = await mapImportOccupationData(occupationData);

            return { ...mappedOccupationData, default: mappedDefaultOccupationData };
        },
    },
    {
        entityName: professionalStatusEntityName,
        label: 'Professional Status',
        onExportMapData: async (response) => {
            const professionalStatus = professionalStatusCTExportSchema.safeParse(response.data);
            if (!professionalStatus.success) return response.data;

            const { default: defaultProfessionalStatusData, ...professionalStatusData } = professionalStatus.data;

            const mappedDefaultProfessionalStatusData = defaultProfessionalStatusData
                ? await mapExportProfessionalStatusData(defaultProfessionalStatusData)
                : undefined;
            const mappedProfessionalStatusData = await mapExportProfessionalStatusData(professionalStatusData);

            return { ...mappedProfessionalStatusData, default: mappedDefaultProfessionalStatusData };
        },
        onImportMapData: async (importData) => {
            const professionalStatus = professionalStatusCTImportSchema.safeParse(importData);
            if (!professionalStatus.success) throw Error('Invalid format');

            const { default: defaultProfessionalStatusData, ...professionalStatusData } = professionalStatus.data;

            const mappedDefaultProfessionalStatusData = defaultProfessionalStatusData
                ? await mapImportProfessionalStatusData(defaultProfessionalStatusData)
                : undefined;
            const mappedProfessionalStatusData = await mapImportProfessionalStatusData(professionalStatusData);

            return { ...mappedProfessionalStatusData, default: mappedDefaultProfessionalStatusData };
        },
    },
    {
        entityName: missionPositionEntityName,
        label: 'Mission Position',
    },
    {
        entityName: missionTypeEntityName,
        label: 'Mission Type',
    },
    {
        entityName: organizationSectionEntityName,
        label: 'Organization Section',
    },
    {
        entityName: organizationTypeEntityName,
        label: 'Organization Type',
    },
    {
        entityName: pagerCarrierEntityName,
        label: 'Pager Carrier',
    },
    {
        entityName: pharmacySpecialtyEntityName,
        label: 'Pharmacy Specialty',
    },
    {
        entityName: physicianAssistantExperienceEntityName,
        label: 'Physician Assistant Experience',
    },
    {
        entityName: priorCommitmentEntityName,
        label: 'Prior Commitment',
    },
    {
        entityName: radiologicSpecialtyEntityName,
        label: 'Radiologic Specialty',
    },
    {
        entityName: referralOptionEntityName,
        label: 'Referral Option',
    },
    {
        entityName: regionEntityName,
        label: 'Region',
    },
    {
        entityName: repeatCallEntityName,
        label: 'Repeat Call',
    },
    {
        entityName: skillEntityName,
        label: 'Skill',
    },
    {
        entityName: trainingEntityName,
        label: 'Training',
    },
    {
        entityName: tribeEntityName,
        label: 'Tribe',
    },
    {
        entityName: veterinarianSpecialtyEntityName,
        label: 'Veterinarian Specialty',
    },
    {
        entityName: writtenAbilityEntityName,
        label: 'Written Ability',
    },
];
